<template>
  <div :class="['input-wraper', `${page_style}`]" v-if="!hide">
    <p class="tip title" v-show="formItem.value || isFleetFunnel">{{ formItem.title }}</p>
    <input
      :class="{ 'has-val': formItem.value || formItem.field_result, 'email_input': formItem.name === 'email' }"
      ref="input"
      :type="formItem.input_type || 'text'"
      v-model="formItem.value"
      :maxlength="formItem.max_length"
      :placeholder="isFleetFunnel ? formItem.placeholder : formItem.title"
      @input="formatInput()"
      :disabled="formItem.field_status == 4"
    />
    <p
      :class="['status-tip', 'tip_' + formItem.field_status]"
      v-show="formItem.field_result"
    >{{ formItem.field_result }}</p>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { post } from "../../tools/request";
import { showAlertDialog } from "../../tools/Tip";
import { ends, SERVICE_PHONE, SOURCE } from "../../tools/constant";

import {
  formatCPFBr,
  formatCNPJBr,
  formatCarPlateBr,
  formatAccent,
  formatCURPMx,
  formatRUT,
  formatCURPCr,
  emitFormUpdate
} from "../../tools/utils";
export default {
  //cm means commit
  //linked_val,是否受其他组件控制，与linked配合使用
  props: ["formItem", "idx", "cm", "linked_val", "page_style"],
  computed: {
    ...mapState(["_ticket", "_mx_id_no_ab_test", "_identity"]),
    hide() {
      // @20211123 this.formItem.hide是墨西哥id_no后置新加的input是否可以隐藏的字段,当实验下发true的时候隐藏
      return (this.formItem.linked && this.formItem.linked !== this.linked_val) 
              || (this.formItem.hide && this._mx_id_no_ab_test);
    },
    location_country() {
      return new URLSearchParams(location.search).get("location_country");
    },
    cpfOmegaItem() {
      return {
        country: this.location_country,
        o_id: Omega.getOmgid()
      }
    },
    isFleetFunnel() {
      return ["h5_funnel_fleet", "h5_funnel_fleet_pc"].includes(this.page_style);
    },
    isGlobalIos() {
      const up = new URLSearchParams(location.search);
      const bundle_id = up.get ('bundle_id') || '';
      const ios_test_bundle_id = "com.didiglobal.driver.inhouse";
      const ios_online_bundle_id = SOURCE.globalIos;
      return bundle_id.indexOf (ios_online_bundle_id) > -1 || bundle_id.indexOf (ios_test_bundle_id) > -1
    }
  },
  mounted() {
    this.formatInput("init");
  },
  watch: {
    "formItem.value"() {
      clearTimeout(this.timeid);
      this.timeid = setTimeout(this.validInput, 350);
    }
  },
  methods: {
    formatCPFBr,
    formatCNPJBr,
    formatCarPlateBr,
    formatAccent,
    formatCURPMx,
    formatRUT,
    formatCURPCr,
    validInput() {
      //Input 依据，regex，valid_api 依次校验，
      let reg = this.formItem.regex,
        valid_api = this.formItem.valid_api;
      if (reg) {
        let r = new RegExp(reg);
        let pass = false;
        let tstr = this.formItem.value.replace(/[\D_]/g, "").slice(0, 4);
        if (tstr.length === 4 && tstr === "0000") {
          pass = true;
        }
        if (pass || r.test(this.formItem.value)) {
          //正则校验通过 icon --->none
          this.formItem.field_result = "";
          if (valid_api) {
            //icon -->>ing
            this.formItem.field_status = 3;
            this.formItem.field_result = this.$t("检测中");
            this.vaildApi();
          } else {
            //icon --->> none
            this.formItem.field_result = "";
            this.checkCommit();
          }
        } else {
          //icon--->>fail
          this.formItem.field_status = 5;
          this.formItem.field_result = this.formItem.regex_remind;
          this.formItem.valid = false;
          emitFormUpdate(this, this.idx);
        }
      } else if (valid_api) {
        //icon -->>ing
        this.formItem.field_status = 3;
        this.formItem.field_result = this.$t("检测中");
        this.vaildApi();
      } else {
        //有值的情况下，再提交
        if (this.formItem.value) {
          this.checkCommit();
        }
      }
    },
    vaildApi() {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      if (this._identity) {
        up.set("identity", this._identity);
      }
      let val = this.formItem.value;
      if (this.formItem.clear_format) {
        val = this[this.formItem.format](val, true);
      }
      up.append("value", val);
      post(this.formItem.valid_api, up)
        .then(() => {
          //提交数据,通过后如果需要直接提交则提交数据
          //icon -->>none
          this.formItem.field_result = "";
          this.checkCommit();
        })
        .catch(res => {
          //icon -->>fail
          this.formItem.field_status = 5;
          this.formItem.valid = false;
          this.formItem.field_result = res.errmsg;
          emitFormUpdate(this, this.idx);
          // 如果没有errmsg代表接口挂了,直接报弹窗错误
          if (!res.errmsg) {
            showAlertDialog(this)
          }
          if (res.data && res.data.phone) {
            // @20220415 快车司机使用新手机号注册MOTO（CPF重复的情况下）
            let that = this;
            this.$createDialog({
              type: 'alert',
              confirmBtn: {
                text: this.isGlobalIos ? this.$t("确认") : this.$t("pc-login-page---GO_LOGIN"),
              },
              showClose: true,
              onConfirm: () => {
                this.cpfConfirm();
              },
              onClose: () => {
                this.cpfClose();
              },
              // cancelBtn: {
              //   text: '取消',
              //   active: true
              // }
            }, (createElement) => {
              return [
                createElement('div', {
                  'class': {
                    'cpf-dialog': true
                  },
                  slot: 'title'
                }, [
                  createElement('div', {
                    'class': {
                      'cpf-dialog-icon': true
                    }
                  }),
                  createElement('div', {
                    'class': {
                      'cpf-dialog-title': true
                    }
                  }, this.$t('GDriver_feature_The_current_Whbj').replace(/{{phone_number}}/, res.data.phone)),
                ]),
                createElement('div', {
                  'class': {
                    'cpf-dialog-tips': true
                  },
                  slot: 'content'
                }, [
                  createElement('p', {
                    'class': {
                      'cpf-dialog-tip': true
                    },
                    on: {
                      click: () => {
                        this.cpfCsClick();
                      }
                    },
                  }, `${this.$t('GDriver_feature_Customer_service_SjhO')}`),
                  // createElement('span', {
                  //   'class': {
                  //     'cpf-dialog-tip-phone': true
                  //   },
                  //   on: {
                  //     click: () => {console.log(3333)}
                  //   },
                  // }, this.$t('GDriver_feature__CS_ODOj'))
                ])
              ]
            }).show()
          }
        });
    },
    cpfConfirm() {
      try {
        Omega.trackEvent("ibt_register_basicinfo_cpf_ck", "", this.cpfOmegaItem);
      } catch (e) {}
      if (!this.isGlobalIos) {
        // 去首页登录
        if (ends.inApp){
          if (ends.isIOS) {
            Fusion.toMainPage({})
          } else {
            Fusion.exitLogin({});
          }
        } else {
          let to = {
            ios: 'https://itunes.apple.com/us/app/99-pop-motorista/id1243302859?ls=1&mt=8',
            android: 'https://play.google.com/store/apps/details?id=com.app99.driver'
          }
          if (ends.isIOS) {
            window.open(to.ios, "_blank");
          } else if (ends.isAndroid) {
            window.open(to.android, "_blank");
          } else {
            window.open(to.android, "_blank");
          }
        }
      }
    },
    cpfClose() {
      try {
        Omega.trackEvent("ibt_register_basicinfo_cpf_cancel_ck", "", this.cpfOmegaItem);
      } catch (e) {}
    },
    cpfCsClick() {
      try {
        Omega.trackEvent("ibt_register_basicinfo_cpf_cs_ck", "", this.cpfOmegaItem);
      } catch (e) {}
      window.location.href = `tel:${SERVICE_PHONE[this.location_country]}`
    },
    formatInput(action = "input") {
      //首先尝试进行格式化
      let format = this.formItem.format;
      if (format) {
        this.formItem.value = this[format](this.formItem.value);
      }
      //如果不需要正则和API校验，且值存在时，则valid置为true
      // @20200811 如果是初始化，且值存在，说明是后端传值，校验已通过
      if ((!this.formItem.regex && !this.formItem.valid_api) || action === "init") {
        if (this.formItem.value) {
          this.formItem.valid = true;
        } else {
          this.formItem.valid = false;
        }
      }
      // @20200811 action如果是init, 表示是初始化, 而不是真正的用户操作值改变了
      emitFormUpdate(this, this.idx, action);
      //初始化时，不调用鼠标定位函数，解决端内触发blur函数的bug
      if (action === "init") {
        return;
      }
      setTimeout(() => {
        let dom = this.$refs["input"] || {};
        let start = dom.selectionStart,
          len = this.formItem.value.length;
        // @20190613 优化体验，自动触发检测
        if (this.formItem.max_length && len == this.formItem.max_length) {
          this.validInput();
        }
        // 兼容手机光标移位问题
        dom.selectionStart = len + 50;
        dom.selectionEnd = len + 50;
      }, 0);
    },
    checkCommit() {
      //if need add
      if (this.cm) {
        this.addInfo();
      } else {
        this.formItem.valid = true;
        emitFormUpdate(this, this.idx);
      }
    },
    //提交物料
    addInfo() {
      // 更新icon --checking
      this.formItem.field_status = 3;
      this.formItem.field_result = this.$t("检测中");
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let val = this.formItem.value;
      if (this.formItem.clear_format) {
        val = this[this.formItem.format](val, true);
      }
      up.append(this.formItem.key, val);
      post(process.env.ADD_AUDI_INFO, up)
        .then(() => {
          // success do nothing
        })
        .catch(err => {
          this.formItem.field_status = 5;
          this.formItem.field_result = err.errmsg;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.input-wraper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 1.4rem;
  box-sizing: border-box;
  padding: 0 0.24rem 0 0.4rem;
  margin-bottom: 0.12rem;
  font-weight: 400;
  background: #fff;
  .tip {
    font-size: 0.28rem;
    line-height: 0.48rem;
    color: #646466;
  }
  input {
    width: 90%;
    transform: translateY(0.24rem);
  }
  .has-val {
    margin: 0.2rem 0;
    transform: none;
  }
}
</style>
<style lang="scss">
.input-wraper.h5_funnel_fleet,
.input-wraper.h5_funnel_fleet_pc {
  margin-bottom: 0.16rem;
  padding: 0.24rem 0.32rem 0 0.32rem;
  input {
    padding: 0.32rem 0;
    width: 100%;
    border-bottom: 1px solid #EEEEEE;
    transform: none;
    font-size: .32rem!important;
    color: #333333;
    font-weight: 700;
    &::-webkit-input-placeholder,
    &::-moz-placeholder,
    &:-moz-placeholder,
    &:-ms-input-placeholder {
        color: #CCCCCC;
    }
    &.has-val {
      margin: 0;
    }
  }
  .title {
    font-size: .24rem;
    color: #666666;
    font-weight: 500;
    line-height: 0.26rem;
  }
  .status-tip::before {
    width: auto;
    height: auto;
    margin-right: 0;
    background: none;
    content: "*";
  }
}
.input-wraper.h5_funnel_fleet_pc {
  margin-bottom: 8px;
  padding: 12px 32px 0 32px;
  input {
    padding: 16px 0;
    font-size: 16px !important;
  }
  .title {
    font-size: 12px;
    line-height: 13px;
  }
}
.cpf-dialog {
  .cpf-dialog-icon {
    width: .88rem;
    height: .88rem;
    margin: 0 auto .24rem auto;
    background: url('../../images/icon_fail@3x.png') 0% 0% / contain no-repeat;
  }
  padding: 0.32rem;
  font-size: 0.32rem;
  color: #666666;
}
.cpf-dialog-tip {
  text-align: center;
  text-decoration: underline;
  font-size: .24rem;
  color: #FF7226;
  opacity: 0.8;
}
</style>
